import { z } from "zod";

import { FilterFieldConfig, FilterItem } from "@/modules/common/filters";

import {
  KNOWLEDGE_BASE_AUDIENCE_OPTIONS,
  KNOWLEDGE_BASE_CATEGORY_OPTIONS,
  KNOWLEDGE_BASE_STATUS_OPTIONS,
  KNOWLEDGE_BASE_TYPE_OPTIONS,
} from "./constants";

const selectMultipleField = (key: string, label: string, options: FilterItem[]): FilterFieldConfig => {
  const allowed = options.map((option) => Number(option.value));
  const schema = z.array(z.coerce.number().refine((value) => allowed.includes(value)));

  return {
    key,
    label,
    type: "select-multiple",
    placement: "both",
    schema,
    options,
    serialize: (value: number[] | undefined) => (value?.length ? value.join(",") : undefined),
    deserialize: (raw) => {
      const parsed = schema.safeParse((raw ?? "").split(",").filter(Boolean));
      return parsed.success && parsed.data.length ? parsed.data : undefined;
    },
  };
};

export const KNOWLEDGE_BASE_FILTER_FIELDS: FilterFieldConfig[] = [
  {
    key: "search",
    label: "Pesquisar",
    type: "text",
    placement: "inline",
    schema: z.string(),
  },
  selectMultipleField("categories", "Categoria", KNOWLEDGE_BASE_CATEGORY_OPTIONS),
  selectMultipleField("types", "Tipo", KNOWLEDGE_BASE_TYPE_OPTIONS),
  selectMultipleField("audiences", "Público", KNOWLEDGE_BASE_AUDIENCE_OPTIONS),
  selectMultipleField("statuses", "Status", KNOWLEDGE_BASE_STATUS_OPTIONS),
];
